import { GetterTree } from 'vuex'
import { WidgetState } from "@/apps/StudentExchangePartnerWidget/models/store-viewmodel"
import {ILabels, ILanguage} from "@/apps/StudentExchangePartnerWidget/models/config-viewmodel";

export default <GetterTree<WidgetState, WidgetState>>{
    getLoading(state): boolean {
        return state.loading
    },
    getLabels(state): ILabels {
        return state.labels
    },
    getSignUp(state): boolean | null {
        return state.signup
    },
    getInsurance(state): boolean {
        return state.insurance
    },
    getPrivacy(state): boolean {
        return state.privacy
    },
    getProgramId(state): number {
        return state.programId
    },
    getRedirectUrl(state): string {
        return state.redirectUrl
    },
    getLanguage(state): ILanguage {
        return state.language
    },
    getErrorMessage(state): String | null {
        return state.errorMessage
    },
    getStudyName(state): String | null {
        return state.studyName
    }
}
